import { render, staticRenderFns } from "./ChartCanvasSb.vue?vue&type=template&id=0ee5955a&scoped=true"
import script from "./ChartCanvasSb.vue?vue&type=script&lang=js"
export * from "./ChartCanvasSb.vue?vue&type=script&lang=js"
import style0 from "./ChartCanvasSb.vue?vue&type=style&index=0&id=0ee5955a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee5955a",
  null
  
)

export default component.exports